<template>
  <div class="review-hearing-test">
    <h1>다비치 히어링</h1>
    <p>다비치 히어링을 소개합니다.</p>
  </div>
</template>

<script>
export default {
  name: 'ReviewHearingTest',
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.review-hearing-test {
  padding: 40px;

  h1 {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  p {
    font-size: 16px;
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    padding: 30px 20px;

    h1 {
      font-size: 24px;
    }

    p {
      font-size: 15px;
    }
  }
}
</style>
